export const formatColumnName = (columnName) => {
  const columnMappings = {
    'title': 'Title',
    'contributors': 'Contributors',
    'publishers': 'Publishers',
    'publication date': 'Publication Date',
    'classification': 'Classification',
    'updatedDate': 'Updated Date',
  };

  return columnMappings[columnName] || columnName
    .split(/[_.]/g)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatCellValue = (value, columnName) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const lowerColumnName = columnName.toLowerCase();

  if (lowerColumnName.includes('date') || lowerColumnName.includes('time')) {
    if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}/)) {
      try {
        return new Date(value);
      } catch (e) {
        return value;
      }
    }
  }

  if (typeof value === 'object' && Array.isArray(value)) {
    return value.join(', ');
  }

  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch (e) {
      return String(value);
    }
  }

  return value;
};

export const getColumnAlignment = (value, columnName) => {
  const lowerColumnName = columnName.toLowerCase();

  if (value instanceof Date || lowerColumnName.includes('date')) {
    return 'center';
  }

  return 'left';
};

export const getNumberFormat = (value) => {
  if (value instanceof Date) {
    return 'dd/mm/yyyy hh:mm';
  }

  if (typeof value === 'number') {
    return '#,##0.##';
  }

  return null;
};
